import { useRef } from "react";
import { Stage, Layer, Text } from "react-konva";
import Konva from "konva";
import { format } from "date-fns";
import KonvaImage from "../atoms/KonvaImage";

type Props = {
	bgImage: string;
	inputName: string;
	inputSolution: string;
	items: Array<string>;
	theme: string;
	w: number;
};

const fontFamily = {
	gothic:
		'"Helvetica Neue",Arial,"Hiragino Kaku Gothic ProN","Hiragino Sans",Meiryo,sans-serif',
	serif:
		'"游明朝", YuMincho, "Hiragino Mincho ProN W3", "ヒラギノ明朝 ProN W3", "Hiragino Mincho ProN", "HG明朝E", "ＭＳ Ｐ明朝", "ＭＳ 明朝", serif',
};

const Test = ({
	bgImage,
	inputName,
	inputSolution,
	items,
	theme,
	w,
}: Props) => {

	const stageRef = useRef<Konva.Stage>(null);
	const temp = stageRef.current;
	const originWidth = 1200;
	const originHeight = 900;


	const downloadURI = (uri: string, name: string) => {
		var link = document.createElement("a");
		link.download = name;
		link.href = uri;
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};

	const handleExport = () => {
			if (temp) {
				const uri = temp.toDataURL({ pixelRatio: 2 });
				downloadURI(uri, 'zetsubo.png');
			}
	};

	const dayInfo = format(new Date(), "yyyy/M/d HH:mm");
	const scaleX = Math.min(w / originWidth);
	return (
		<>
			<Stage
				ref={stageRef}
				scaleX={scaleX}
				scaleY={scaleX}
				width={originWidth * scaleX}
				height={originHeight * scaleX}
				className="my-2"
			>
				<Layer>
					<KonvaImage
						image={bgImage}
						x={0}
						y={0}
						width={originWidth}
						height={originHeight}
					/>
					<Text
						text={dayInfo}
						x={40}
						y={830}
						width={360}
						fontSize={36}
						fontFamily={fontFamily.gothic}
						fontStyle={"bold"}
						fill="black"
						align="left"
					/>
					<Text
						text={inputName}
						x={330}
						y={831}
						width={310}
						fontSize={32}
						fontFamily={fontFamily.gothic}
						fontStyle={"bold"}
						fill="black"
						align="left"
					/>
					<Text
						text="＃俺が助けた"
						x={640}
						y={831}
						width={600}
						fontSize={32}
						fontFamily={fontFamily.gothic}
						fontStyle={"bold"}
						fill="black"
						align="left"
					/>
					<Text
						text={inputSolution}
						x={70}
						y={490}
						width={800}
						fontSize={56}
						fontFamily={fontFamily.gothic}
						fill="white"
						align="left"
					/>
					<KonvaImage
						image={items[0]}
						x={645}
						y={105}
						width={235}
						height={320}
					/>
					<KonvaImage
						image={items[1]}
						x={910}
						y={105}
						width={235}
						height={320}
					/>
					<KonvaImage image={theme} x={40} y={70} width={528} height={379} />
				</Layer>
			</Stage>
			<button onClick={handleExport} className="bg-orange-500 drop-shadow text-white font-bold text-xl rounded-lg py-2 px-10 active:scale-105">画像をDLする</button>
		</>
	);
};

export default Test;
